import React from 'react';
import { Route } from 'react-router-dom';
import SwitchRouter from 'components/SwitchRouter';
import Inicio from './dashboard/Inicio';
import AnaliseDocumentos from './analise-documentos/AnaliseDocumentos';
import { Importar } from './xml/Importar';

export default function Routes({ match: { path } }) {
    const routes = [
        { path: `${path}/dashboard`, component: Inicio },
        { path: `${path}/analise-de-documentos`, component: AnaliseDocumentos },
        { path: `${path}/importar-xmls`, component: Importar },
    ];

    return (
        <SwitchRouter>
            {routes.map((props, i) => (
                <Route key={i} {...props} />
            ))}
        </SwitchRouter>
    );
}
